"use strict";
// dev help: These are the commands that supported from the Server is self.
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_crypt_1 = require("dyna-crypt");
var DynaNodeAddress_1 = require("../DynaNodeAddress/DynaNodeAddress");
var consoleStringify_1 = require("../utils/consoleStringify");
var DynaNodeServerAPI = /** @class */ (function () {
    function DynaNodeServerAPI(_config) {
        this._config = _config;
    }
    DynaNodeServerAPI.prototype.processMessage = function (message) {
        switch (message.command) {
            case 'dyna-node/server/changeConnectionId':
                this._changeConnectionId(message);
                break;
            case 'dyna-node/server/prefixConnectionId':
                this._prefixConnectionId(message);
                break;
            case 'ping':
                this._ping(message);
                break;
            case 'dyna-node/serverAddresses/request':
                this._getServerAddresses(message);
                break;
            case 'dyna-node/server/stats':
                this._stats(message);
                break;
            case 'error/dyna-node/404/101':
                this._404101(message);
                break;
            default:
                this._commandNotFound(message);
                break;
        }
    };
    DynaNodeServerAPI.prototype._changeConnectionId = function (message) {
        var serverConnectionConfig = this._config.connectionIds
            && this._config.connectionIds[message.args.connectionId];
        if (!serverConnectionConfig) {
            this._config.postMessage(message.reply({
                command: "error/dyna-node/303",
                data: {
                    message: "You don't exist here, are you hacking?",
                },
            })); // this changeId is not supported from this server
            return;
        }
        var security = dyna_crypt_1.decryptEx(message.args.security, serverConnectionConfig.encryptionKey);
        if (!security) {
            this._config.postMessage(message.reply({
                command: "error/dyna-node/308",
                data: {
                    code: 202011040934,
                    message: "Service registration [" + message.args.connectionId + "]: Invalid credentials",
                },
            })); // wrong encryption key
            return;
        }
        if (security.accessKey !== serverConnectionConfig.accessKey) {
            this._config.postMessage(message.reply({
                command: "error/dyna-node/308",
                data: {
                    code: 202011040934,
                    message: "Service registration [" + message.args.connectionId + "]: Invalid credentials",
                },
            })); // wrong access key
            return;
        }
        switch (message.args.changeConnectionIdVersion) {
            case '2.3':
                // change the connection id to new one
                this._config.changeConnectionIdForService((new DynaNodeAddress_1.DynaNodeAddress(message.from)).connectionId, message.args.connectionId);
                // send message to the requested for this change as ok
                var replyMessage = message.reply({ command: 'ok' });
                var newAddr = new DynaNodeAddress_1.DynaNodeAddress(replyMessage.to);
                newAddr.connectionId = message.args.connectionId; // use the new defined connection id
                replyMessage.to = newAddr.address;
                this._config.postMessage(replyMessage);
                break;
            default:
                this._config.postMessage(message.reply({
                    command: "error/dyna-node/310",
                    data: {
                        message: 'changeConnectionIdVersion is not supported',
                    },
                }));
        }
    };
    DynaNodeServerAPI.prototype._prefixConnectionId = function (message) {
        var prefixConnectionId = message.args.prefixConnectionId;
        var currentConnectionId = (new DynaNodeAddress_1.DynaNodeAddress(message.from)).connectionId;
        var newConnectionId = prefixConnectionId + "--" + currentConnectionId;
        // change the connection id to new one
        this._config.changeConnectionIdForService(currentConnectionId, newConnectionId);
        // send message to the requested for this change as ok
        var replyMessage = message.reply({ command: 'ok' });
        var newAddr = new DynaNodeAddress_1.DynaNodeAddress(replyMessage.to);
        newAddr.connectionId = newConnectionId; // use the new defined connection id
        replyMessage.to = newAddr.address;
        this._config.postMessage(replyMessage);
    };
    DynaNodeServerAPI.prototype._ping = function (message) {
        this._config.postMessage(message.reply({
            command: 'pong',
            data: {
                yourIpAddress: message.dynaNodeInfo.fromIpAddress,
                serverTime: new Date,
            },
        }));
    };
    DynaNodeServerAPI.prototype._stats = function (message) {
        this._config.postMessage(message.reply({
            command: 'dyna-node/server/stats',
            data: this._config.getStats(),
        }));
    };
    DynaNodeServerAPI.prototype._getServerAddresses = function (message) {
        this._config.postMessage(message.reply({
            command: 'dyna-node/serverAddresses/response',
            data: this._config.getServerAddresses(),
        }));
    };
    DynaNodeServerAPI.prototype._404101 = function (message) {
        console.error('DynaNodeServer, 1904281915 received error/dyna-node/404/101', consoleStringify_1.consoleStringify(message.viewSecure));
    };
    DynaNodeServerAPI.prototype._commandNotFound = function (message) {
        if (message.command.indexOf("error") === 0) {
            console.error("DynaNodeServer: incoming message is error (command: " + message.command + ") and is discarded. You should not send errors here!", consoleStringify_1.consoleStringify(message.viewSecure));
            return;
        }
        this._config.postMessage(message.reply({
            command: "error/dyna-node/405",
            data: {
                code: 405,
                section: "DynaNodeServerAPI",
                message: "DynaNodeServerAPI command not found [" + message.command + "]",
            },
        }));
    };
    return DynaNodeServerAPI;
}());
exports.DynaNodeServerAPI = DynaNodeServerAPI;
//# sourceMappingURL=DynaNodeServerAPI.js.map